import { Check } from "lucide-react";
import * as React from "react";

import { cn } from "@/lib/utils/cn";

export interface StepperStep {
  title: string;
}

interface StepperProps {
  steps: StepperStep[];
  currentStep: number;
  className?: string;
}

function Stepper({ steps, currentStep, className }: StepperProps) {
  return (
    <div
      data-slot="stepper"
      className={cn("flex items-center gap-2", className)}
    >
      {steps.map((step, index) => {
        const isActive = index === currentStep;
        const isCompleted = index < currentStep;

        return (
          <React.Fragment key={index}>
            <div data-slot="stepper-step" className="flex items-center gap-2">
              <div
                className={cn(
                  "flex size-8 shrink-0 items-center justify-center rounded-full border-2 text-sm font-semibold transition-colors",
                  isCompleted &&
                    "border-success bg-success text-success-foreground",
                  isActive && "border-primary text-primary",
                  !isActive &&
                    !isCompleted &&
                    "border-muted-foreground/40 text-muted-foreground"
                )}
              >
                {isCompleted ? <Check className="size-4" /> : index + 1}
              </div>
              <span
                className={cn(
                  "text-sm font-semibold whitespace-nowrap",
                  isActive ? "text-primary" : "text-foreground"
                )}
              >
                {step.title}
              </span>
            </div>
            {index < steps.length - 1 && (
              <div
                aria-hidden="true"
                className="bg-border h-px min-w-4 flex-1"
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}

export { Stepper };
